import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MOSAICCOMOLINKACCOUNTCARDBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "text",
  "background_color",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  mosaicComoLinkAccountCardBlockDescriptor: _generatedMosaicComoLinkAccountCardBlockDescriptor,
  mosaicComoLinkAccountCardBlockBlocDefinition,
  mosaicComoLinkAccountCardBlockDashboardLayout,
  mosaicComoLinkAccountCardBlockConfig,
  mosaicComoLinkAccountCardBlockResolveConfig,
  mosaicComoLinkAccountCardBlockProperties,
} = doodBlockConfig(
  {
    name: "Como - Link account card",
    componentType: 'MosaicComoLinkAccountCardBlockComponent',
    category: 'como',
    description: "Como - Link account card.",
    keywords: [],
    allowedIn: [
      { bloc: "MosaicBlockComponent", slot: "cards" },
    ],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.mosaic-como-link-account-card.heading.label",
      }
    }),
    text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.mosaic-como-link-account-card.text.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"highlight-600"},
      options: {
        label: "pages.blocks.mosaic-como-link-account-card.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.mosaic-como-link-account-card.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.mosaic-como-link-account-card.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.mosaic-como-link-account-card.fieldset.texts.label",
            fields: ["heading", "text", "text_color"],
          },
          {
            legend: "pages.blocks.mosaic-como-link-account-card.fieldset.background.label",
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function mosaicComoLinkAccountCardBlockDescriptor(): IBlockDescriptor;
export function mosaicComoLinkAccountCardBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function mosaicComoLinkAccountCardBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMosaicComoLinkAccountCardBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMosaicComoLinkAccountCardBlockDescriptor, mosaicComoLinkAccountCardBlockProperties, fieldOrder);
}

export {
  mosaicComoLinkAccountCardBlockBlocDefinition,
  mosaicComoLinkAccountCardBlockDashboardLayout,
  mosaicComoLinkAccountCardBlockProperties,
  mosaicComoLinkAccountCardBlockConfig,
  mosaicComoLinkAccountCardBlockResolveConfig,
};

export type MosaicComoLinkAccountCardBlockConfig = typeof mosaicComoLinkAccountCardBlockConfig;
